/* istanbul ignore file */

import { batch, connect } from 'react-redux';

import type { QuickFiltersProps } from 'src/components/organisms/Filter/components/QuickFilters';
import { QuickFilters } from 'src/components/organisms/Filter/components/QuickFilters';
import { actions as filterActions } from 'src/components/organisms/Filter/modules/slice';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectFilterOptions, selectSelectedFilterOptions } from 'src/redux/products/selectors';
import { updateFilters, UpdateFiltersActionType } from 'src/redux/products/thunks/updateFilters';
import type { AppThunkDispatch } from 'src/redux/store';
import type { SelectedFilterOption } from 'src/types';

const mapStateToProps = (state: ReduxApplicationState, ownProps: QuickFiltersProps) => ({
  filterLinks: selectFilterOptions(state, ownProps.filterUid),
  selectedFilterOptions: selectSelectedFilterOptions(state, ownProps.filterUid),
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  onSelectFilterOption: (selectedFilterOption: SelectedFilterOption) => {
    batch(() => {
      dispatch(filterActions.selectFilterOption(selectedFilterOption));
      dispatch(updateFilters(UpdateFiltersActionType.FILTER));
    });
  },
});

export const QuickFiltersContainer = connect(mapStateToProps, mapDispatchToProps)(QuickFilters);
